/**
 * @generated SignedSource<<037ce9b7528ea339cdb2e61d1672c6d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BillingPlanInterval = "MONTH" | "YEAR" | "%future added value";
export type BillingPlanType = "CUSTOM" | "STANDARD" | "%future added value";
export type UserOrganizationRole = "ADMIN" | "MEMBER" | "%future added value";
export type fetchOrgBySlugQuery$variables = {
  slug: string;
};
export type fetchOrgBySlugQuery$data = {
  readonly organizationBySlug: {
    readonly id: string;
    readonly rowId: any;
    readonly name: string;
    readonly legalName: string | null;
    readonly slug: string;
    readonly createdAt: any;
    readonly organizationSubscriptions: {
      readonly nodes: ReadonlyArray<{
        readonly config: any | null;
        readonly billingPlan: {
          readonly rowId: any;
          readonly slug: string;
          readonly name: string;
          readonly price: number;
          readonly type: BillingPlanType;
          readonly interval: BillingPlanInterval;
          readonly stripePriceId: string | null;
          readonly config: any | null;
        } | null;
        readonly updatedAt: any;
        readonly status: string;
        readonly endsAt: any | null;
        readonly deletedAt: any | null;
      }>;
    };
    readonly organizationCompanies: {
      readonly totalCount: number;
      readonly nodes: ReadonlyArray<{
        readonly organization: {
          readonly id: string;
        } | null;
        readonly company: {
          readonly id: string;
        } | null;
      }>;
    };
    readonly organizationUsers: {
      readonly nodes: ReadonlyArray<{
        readonly user: {
          readonly id: string;
        } | null;
        readonly role: UserOrganizationRole;
      }>;
    };
  } | null;
};
export type fetchOrgBySlugQuery = {
  variables: fetchOrgBySlugQuery$variables;
  response: fetchOrgBySlugQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legalName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "includeDeleted",
    "value": "YES"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "UPDATED_AT_DESC"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "config",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interval",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stripePriceId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = [
  (v2/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "company",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchOrgBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organizationBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "OrganizationSubscriptionsConnection",
            "kind": "LinkedField",
            "name": "organizationSubscriptions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationSubscription",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingPlan",
                    "kind": "LinkedField",
                    "name": "billingPlan",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v4/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "organizationSubscriptions(includeDeleted:\"YES\",orderBy:\"UPDATED_AT_DESC\")"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "OrganizationCompaniesConnection",
            "kind": "LinkedField",
            "name": "organizationCompanies",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationCompany",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "organizationCompanies(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationUsersConnection",
            "kind": "LinkedField",
            "name": "organizationUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationUser",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchOrgBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organizationBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "OrganizationSubscriptionsConnection",
            "kind": "LinkedField",
            "name": "organizationSubscriptions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationSubscription",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingPlan",
                    "kind": "LinkedField",
                    "name": "billingPlan",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v4/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "organizationSubscriptions(includeDeleted:\"YES\",orderBy:\"UPDATED_AT_DESC\")"
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "OrganizationCompaniesConnection",
            "kind": "LinkedField",
            "name": "organizationCompanies",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationCompany",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "organizationCompanies(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationUsersConnection",
            "kind": "LinkedField",
            "name": "organizationUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationUser",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7ca75efa21c937dd34e8568428513976",
    "id": null,
    "metadata": {},
    "name": "fetchOrgBySlugQuery",
    "operationKind": "query",
    "text": "query fetchOrgBySlugQuery(\n  $slug: String!\n) {\n  organizationBySlug(slug: $slug) {\n    id\n    rowId\n    name\n    legalName\n    slug\n    createdAt\n    organizationSubscriptions(includeDeleted: YES, orderBy: UPDATED_AT_DESC) {\n      nodes {\n        config\n        billingPlan {\n          rowId\n          slug\n          name\n          price\n          type\n          interval\n          stripePriceId\n          config\n          id\n        }\n        updatedAt\n        status\n        endsAt\n        deletedAt\n        id\n      }\n    }\n    organizationCompanies(first: 1) {\n      totalCount\n      nodes {\n        organization {\n          id\n        }\n        company {\n          id\n        }\n        id\n      }\n    }\n    organizationUsers {\n      nodes {\n        user {\n          id\n        }\n        role\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab4baf10cac0650ed800988eb499b354";

export default node;
